export default "__VITE_ASSET__bw7EgW0c__"